export { default } from './ownerWindow';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ownerWindow/index.js
// module id = 745
// module chunks = 22